// Configuration for chat feature availability
// Add organization IDs that should have access to the chat feature
export const CHAT_ENABLED_ORG_IDS = [
  // Add organization IDs here
  // Example: 1, 2, 3, 4
];

/**
 * Check if chat feature is enabled for a given organization
 * @param {number} orgId - The organization ID
 * @returns {boolean} - Whether chat is enabled for this org
 */
export const isChatEnabledForOrg = (orgId) => {
  return true;
};

/**
 * Check if chat feature is enabled for a project
 * @param {object} project - The project object with organization info
 * @returns {boolean} - Whether chat is enabled for this project's org
 */
export const isChatEnabledForProject = (project) => {
  return true;
  if (!project || !project.organization) {
    return false;
  }
  return isChatEnabledForOrg(project.organization);
};
